// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1B3cK","additionalInfo":"AgreementModal_additionalInfo__mgOcK"};